import { Badge } from '../../components/ui/badge';

const CONFIG = {
  pending: { label: 'PENDING RENEWAL', className: 'bg-orange-100 text-orange-700 hover:bg-orange-100' },
  in_progress: { label: 'IN PROGRESS', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
  renewed: { label: 'RENEWED', className: 'bg-green-100 text-green-700 hover:bg-green-100' },
  not_applicable: { label: 'NOT APPLICABLE', className: 'bg-slate-100 text-slate-500 hover:bg-slate-100' },
};

export function RenewalStatusBadge({ status }) {
  const cfg = CONFIG[status] || CONFIG.not_applicable;
  return <Badge className={`font-semibold ${cfg.className}`}>{cfg.label}</Badge>;
}
